;(function($) {
  "use strict"
  $(function() {
    $(document).click(function(e) {
      const $currItem = $(e.target).closest(".field__fuel")
      if ($currItem.length !== 0) {
        $currItem.toggleClass("field__fuel_disabled")
      }
    })

    $(document).click(function(e) {
      const $currItem = $(e.target).closest(".field__add")
      if ($currItem.length !== 0) {
      $('.field__input_additional input.field__input').attr('placeholder','Точка маршрута');
      }
    })
    $(".field__input").keyup(function() {
      const currVal = $(this).val()
      const $blockInfo = $(this)
        .closest("label")
        .find(".field__extra")

      if (currVal != "") {
        $blockInfo.removeClass("hide")
      } else {
        $blockInfo.addClass("hide")
      }
    })
  })
})(jQuery)
